import ParcelOrders from "./ParcelOrders";
import React, { useCallback, useEffect, useMemo, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";

import {

  getOperationsUser,

  getOperationsOrders,

  getPendingCashPayments,

  getSuccessfulOperationsOrders,

  getFailedOnlineOperationsOrders,

  approveOperationsOrder,

  collectOperationsCash,

  operationsLogout,

  getOperationsTables, getOperationsTable, createOperationsTable, updateOperationsTable,

  openOperationsTableSession, closeOperationsTableSession,

} from "./operationsApi";

import "./operations.css";
import useNewOrderSound from "../components/useNewOrderSound";

// Date filtering uses the browser's local calendar day.

function localDateKey(date) {

  const year = date.getFullYear();

  const month = String(date.getMonth() + 1).padStart(2, "0");

  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;

}

function formatHistoryDate(value) {

  if (!value) return "—";

  const date = new Date(value);

  return Number.isNaN(date.getTime()) ? "—" : date.toLocaleString();

}

function orderDateKey(order) {

  const raw = order.created_at;

  if (!raw) return null;

  const date = new Date(raw);

  return Number.isNaN(date.getTime()) ? null : localDateKey(date);

}

const ACTIVE = ["PENDING", "CONFIRMED", "PREPARING", "READY"];

const TERMINAL = ["CANCELLED", "COMPLETED"];

function methodOf(o) {

  return o.payment_method || o.payment?.payment_method || "UNKNOWN";

}

function paymentOf(o) {

  return o.payment?.status || (o.payment_status === "PAID" ? "SUCCESS" : o.payment_status) || "PENDING";

}

function tableOf(o) {

  return o.table_number ?? o.table?.table_number ?? o.table?.number ?? "—";

}

function amountOf(o) {

  return o.total ?? o.order_total ?? o.amount ?? "—";

}

function itemName(item) {

  return item.item_name || item.menu_item_name || item.name || item.menu_item?.name || "Menu Item";

}

function canApprove(o) {

  if (o.manager_approval_status !== "PENDING" || !["PENDING", "CONFIRMED"].includes(o.status)) return false;

  if (o.payment_status === "REFUNDED" || paymentOf(o) === "REFUNDED") return false;

  if (methodOf(o) === "CASH") return true;

  return methodOf(o) === "ONLINE" && o.payment_status === "PAID" && paymentOf(o) === "SUCCESS";

}

function currency(v) {

  const n = Number(v);

  return Number.isFinite(n) ? `₹${n.toFixed(2)}` : "—";

}

function OrderCard({ order, action, actionText, busy, note }) {

  return (

    <article className="ops-order-card">

      <div className="ops-order-header">

        <div>

          <h3>Order #{order.order_number || order.id || order.order_id}</h3>

          <p>Table {tableOf(order)} · ID {order.id || order.order_id}</p>

        </div>

        <span className={`ops-status ${String(order.status || order.order_status || "").toLowerCase()}`}>

          {order.status || order.order_status || "UNKNOWN"}

        </span>

      </div>

      <div className="ops-order-details">

        <p><strong>Payment:</strong> {methodOf(order)} · {paymentOf(order)}</p>

        <p><strong>Approval:</strong> {order.manager_approval_status || order.approval_status || "—"}</p>

        <p><strong>Total:</strong> {currency(amountOf(order))}</p>

      </div>

      {Array.isArray(order.items) && order.items.length > 0 && (

        <div className="ops-order-items">

          {order.items.map((item, i) => (

            <div key={item.id || i}>{item.quantity || 1} × {itemName(item)}</div>

          ))}

        </div>

      )}

      {note && <p className="ops-waiting-message">{note}</p>}

      {action && (

        <button type="button" className="ops-approve-btn" disabled={busy} onClick={action}>

          {busy ? "Processing..." : actionText}

        </button>

      )}

    </article>

  );

}

function receiptDate(value) {

  if (!value) return "—";

  const date = new Date(value);

  return Number.isNaN(date.getTime()) ? "—" : date.toLocaleString();

}

function PrintBill({ order, restaurant, onClose }) {

  const [paper, setPaper] = useState("80mm");

  const items = Array.isArray(order.items) ? order.items : [];

  const restaurantName = order.restaurant_name || restaurant || "Restaurant";

  const reference = order.payment_transaction_id || order.payment?.razorpay_payment_id || order.payment?.transaction_id;

  const paid = order.payment_status === "PAID" &&

    (order.payment_record_status || paymentOf(order)) === "SUCCESS" &&

    order.manager_approval_status === "APPROVED";

  useEffect(() => {

    const previous = document.body.style.overflow;

    document.body.style.overflow = "hidden";

    const onKey = event => { if (event.key === "Escape") onClose(); };

    document.addEventListener("keydown", onKey);

    return () => {

      document.body.style.overflow = previous;

      document.removeEventListener("keydown", onKey);

    };

  }, [onClose]);

  if (!paid) return null;

  return (

    <div className="ops-print-overlay" role="dialog" aria-modal="true" aria-label="Individual order receipt">

      <div className="ops-receipt-window">

        <div className="ops-no-print ops-receipt-toolbar">

          <div><strong>Receipt preview</strong><small>Order #{order.order_number || order.id} · Separate bill</small></div>

          <div className="ops-receipt-controls">

            <label htmlFor="ops-paper-size">Paper</label>

            <select id="ops-paper-size" value={paper} onChange={e => setPaper(e.target.value)}>

              <option value="80mm">80 mm</option>

              <option value="58mm">58 mm</option>

              <option value="a4">A4</option>

            </select>

            <button type="button" className="ops-secondary-btn" onClick={onClose}>Close</button>

            <button type="button" className="ops-primary-btn" onClick={() => window.print()}>Print receipt</button>

          </div>

        </div>

        <div className={`ops-print-receipt ops-paper-${paper}`}>

          <div className="ops-receipt-heading">

            <h2>{restaurantName}</h2>

            {order.restaurant_address && <p>{order.restaurant_address}</p>}

            {order.restaurant_phone && <p>Tel: {order.restaurant_phone}</p>}

            <strong>PAYMENT RECEIPT</strong>

          </div>

          <div className="ops-receipt-rule" />

          <div className="ops-receipt-meta">

            <div><span>Order number</span><strong>#{order.order_number || order.id}</strong></div>

            <div><span>Table</span><span>{tableOf(order)}</span></div>

            {order.dining_session_id != null && <div><span>Dining session</span><span>#{order.dining_session_id}</span></div>}

            <div><span>Ordered at</span><span>{receiptDate(order.created_at)}</span></div>

            <div><span>Paid at</span><span>{receiptDate(order.paid_at)}</span></div>

            <div><span>Payment method</span><span>{methodOf(order)}</span></div>

            <div><span>Payment status</span><strong>PAID</strong></div>

            {order.collected_by && <div><span>Collected by</span><span>{order.collected_by}</span></div>}

            {reference && <div className="ops-receipt-reference"><span>Transaction ref.</span><span>{reference}</span></div>}

          </div>

          <div className="ops-receipt-rule" />

          <table className="ops-receipt-items">

            <thead><tr><th>Item</th><th>Qty</th><th>Rate</th><th>Amount</th></tr></thead>

            <tbody>

              {items.map((item, index) => (

                <tr key={item.id || index}>

                  <td>{itemName(item)}</td>

                  <td>{item.quantity}</td>

                  <td>{currency(item.price)}</td>

                  <td>{currency(item.total)}</td>

                </tr>

              ))}

            </tbody>

          </table>

          <div className="ops-receipt-rule" />

          <div className="ops-receipt-totals">

            <div><span>Subtotal</span><span>{currency(order.subtotal)}</span></div>

            <div><span>Tax</span><span>{currency(order.tax)}</span></div>

            <div><span>Discount</span><span>− {currency(order.discount)}</span></div>

            <div className="ops-receipt-grand"><strong>TOTAL PAID</strong><strong>{currency(order.total)}</strong></div>

          </div>

          <div className="ops-receipt-footer">Thank you for visiting!<small>This receipt covers only order #{order.order_number || order.id}.</small></div>

        </div>

      </div>

    </div>

  );

}

export default function OperationsDashboard() {

  const { restaurantId } = useParams();

  const navigate = useNavigate();
  const { soundEnabled, enableSound, disableSound, observeOrders } = useNewOrderSound(restaurantId);

  const [staff, setStaff] = useState(null);

  const [tablesData, setTablesData] = useState({ tables: [] });

  const [tableDetail, setTableDetail] = useState(null);

  const [tableBusy, setTableBusy] = useState(false);

  const [tableForm, setTableForm] = useState(null);

  const [orders, setOrders] = useState([]);

  const [pendingCash, setPendingCash] = useState([]);

  const [successful, setSuccessful] = useState([]);

  const [failed, setFailed] = useState([]);

  const [loading, setLoading] = useState(true);

  const [refreshing, setRefreshing] = useState(false);

  const [busyOrderId, setBusyOrderId] = useState(null);

  const [loggingOut, setLoggingOut] = useState(false);

  const [error, setError] = useState("");

  const [success, setSuccess] = useState("");

  const [tab, setTab] = useState("overview");

  const [menuOpen, setMenuOpen] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");

  const [collecting, setCollecting] = useState(null);

  const [printOrder, setPrintOrder] = useState(null);

  const [datePreset, setDatePreset] = useState("today");

  const [historyPreset, setHistoryPreset] = useState("last7");

  const [historyStart, setHistoryStart] = useState("");

  const [historyEnd, setHistoryEnd] = useState("");

  const [historyMethod, setHistoryMethod] = useState("all");

  const [historyStatus, setHistoryStatus] = useState("all");

  const [todayKey, setTodayKey] = useState(() => localDateKey(new Date()));

  const [startDate, setStartDate] = useState(() => localDateKey(new Date()));

  const [endDate, setEndDate] = useState(() => localDateKey(new Date()));

  // The dashboard rolls over to the new day even when the tab stays open.

  useEffect(() => {

    const tick = () => setTodayKey(localDateKey(new Date()));

    const timer = setInterval(tick, 30000);

    window.addEventListener("focus", tick);

    return () => {

      clearInterval(timer);

      window.removeEventListener("focus", tick);

    };

  }, []);

  const loadAll = useCallback(async (quiet = false) => {

    try {

      const [all, cash, paid, failures] = await Promise.all([

        getOperationsOrders(restaurantId),

        getPendingCashPayments(restaurantId),

        getSuccessfulOperationsOrders(restaurantId),

        getFailedOnlineOperationsOrders(restaurantId),

      ]);

      const nextOrders = Array.isArray(all.orders) ? all.orders : [];
    observeOrders(nextOrders.filter(canApprove));
    setOrders(nextOrders);

      setPendingCash(Array.isArray(cash.payments) ? cash.payments : []);

      setSuccessful(Array.isArray(paid.orders) ? paid.orders : []);

      setFailed(Array.isArray(failures.orders) ? failures.orders : []);

      if (!quiet) setError("");

    } catch (err) {

      if (!quiet) setError(err.message || "Unable to load dashboard data.");

    }

  }, [restaurantId, observeOrders]);

  useEffect(() => {

    let active = true;

    async function initialize() {

      try {

        const user = await getOperationsUser(restaurantId);

        if (!active) return;

        setStaff(user);

        await loadAll();

      } catch (err) {

        if (!active) return;

        setError(err.message || "Unable to authenticate.");

        navigate(`/operations/${restaurantId}`, { replace: true });

      } finally {

        if (active) setLoading(false);

      }

    }

    initialize();

    return () => { active = false; };

  }, [restaurantId, navigate, loadAll]);

  useEffect(() => {

    if (!staff) return undefined;

    const interval = setInterval(() => {

      if (!document.hidden && busyOrderId === null && !collecting) loadAll(true);

    }, 5000);

    return () => clearInterval(interval);

  }, [staff, loadAll, busyOrderId, collecting]);

  const loadTables = useCallback(async (quiet = false) => {

    try {

      const result = await getOperationsTables(restaurantId);

      setTablesData(result);

      if (!quiet) setError("");

    } catch (err) { if (!quiet) setError(err.message || "Unable to load tables."); }

  }, [restaurantId]);

  useEffect(() => {

    if (!staff) return undefined;

    loadTables(true);

    const interval = setInterval(() => { if (!document.hidden && !tableBusy) loadTables(true); }, 5000);

    return () => clearInterval(interval);

  }, [staff, loadTables, tableBusy]);

  async function viewTable(tableId) {

    try { setTableDetail(await getOperationsTable(restaurantId, tableId)); setError(""); }

    catch (err) { setError(err.message); }

  }

  async function tableAction(action, message) {

    if (tableBusy) return;

    if (message && !window.confirm(message)) return;

    setTableBusy(true); setError(""); setSuccess("");

    try {

      await action();

      await loadTables(true);

      if (tableDetail?.table?.id) {

        setTableDetail(await getOperationsTable(restaurantId, tableDetail.table.id));

      }

      setSuccess("Table updated successfully.");

    } catch (err) {

      const detail = err.blocking_orders?.map(o => `${o.order_number}: ${o.reason}`).join("; ");

      setError([err.message, detail].filter(Boolean).join(" — "));

    } finally { setTableBusy(false); }

  }

  async function saveTable(event) {

    event.preventDefault();

    const values = {table_number: tableForm.table_number.trim(), capacity: Number(tableForm.capacity)};

    if (!values.table_number || values.capacity < 1) { setError("Enter a table number and valid capacity."); return; }

    setTableBusy(true); setError("");

    try {

      if (tableForm.id) await updateOperationsTable(restaurantId, tableForm.id, values);

      else await createOperationsTable(restaurantId, values);

      setTableForm(null); await loadTables(true); setSuccess("Table saved successfully.");

    } catch (err) { setError(err.message); }

    finally { setTableBusy(false); }

  }

  async function refresh() {

    setRefreshing(true);

    try { await loadAll(); } finally { setRefreshing(false); }

  }

  async function approve(id) {

    if (busyOrderId !== null) return;

    setBusyOrderId(id);

    setError(""); setSuccess("");

    try {

      await approveOperationsOrder(restaurantId, id);

      setSuccess(`Order #${id} approved for kitchen.`);

      await loadAll();

    } catch (err) {

      setError(err.message || "Approval failed.");

    } finally { setBusyOrderId(null); }

  }

  async function collect() {

    if (!collecting || busyOrderId !== null) return;

    const id = collecting.order_id;

    setBusyOrderId(id);

    setError(""); setSuccess("");

    try {

      await collectOperationsCash(restaurantId, id);

      setCollecting(null);

      setSuccess(`Cash collected for order #${id}. The order is now in Successful Orders & Bills.`);

      await loadAll();

      setTab("paid");

    } catch (err) {

      setError(err.message || "Cash collection failed.");

      setCollecting(null);

      await loadAll(true);

    } finally { setBusyOrderId(null); }

  }

  async function logout() {

    if (loggingOut) return;

    setLoggingOut(true);

    try {

      await operationsLogout(restaurantId);

      navigate(`/operations/${restaurantId}`, { replace: true });

    } catch (err) {

      setError(err.message || "Logout failed.");

      setLoggingOut(false);

    }

  }

  const dateMatches = useCallback((order) => {

    if (datePreset === "all") return true;

    const key = orderDateKey(order);

    if (!key) return false;

    if (datePreset === "today") return key === todayKey;

    if (datePreset === "yesterday") {

      const d = new Date(`${todayKey}T12:00:00`);

      d.setDate(d.getDate() - 1);

      return key === localDateKey(d);

    }

    if (datePreset === "last7") {

      const d = new Date(`${todayKey}T12:00:00`);

      d.setDate(d.getDate() - 6);

      return key >= localDateKey(d) && key <= todayKey;

    }

    if (datePreset === "custom") {

      return (!startDate || key >= startDate) && (!endDate || key <= endDate);

    }

    return true;

  }, [datePreset, todayKey, startDate, endDate]);

  const visibleOrders = useMemo(() => orders.filter(dateMatches), [orders, dateMatches]);

  const visibleCash = useMemo(() => pendingCash.filter(dateMatches), [pendingCash, dateMatches]);

  const visibleSuccessful = useMemo(() => successful.filter(dateMatches), [successful, dateMatches]);

  const visibleFailed = useMemo(() => failed.filter(dateMatches), [failed, dateMatches]);

  const approvals = useMemo(() => visibleOrders.filter(canApprove), [visibleOrders]);

  const kitchen = useMemo(() => visibleOrders.filter(o =>

    o.manager_approval_status === "APPROVED" && ACTIVE.includes(o.status)

  ), [visibleOrders]);

  const pendingOnline = useMemo(() => visibleOrders.filter(o =>

    methodOf(o) === "ONLINE" && paymentOf(o) === "PENDING" &&

    !TERMINAL.includes(o.status) && o.manager_approval_status === "PENDING"

  ), [visibleOrders]);

  // History always uses the unfiltered records, independent of the daily dashboard.

  const historyDateMatches = useCallback((record, dateField) => {

    const raw = record[dateField] || record.created_at;

    if (!raw) return historyPreset === "all";

    const parsed = new Date(raw);

    if (Number.isNaN(parsed.getTime())) return false;

    const key = localDateKey(parsed);

    if (historyPreset === "all") return true;

    if (historyPreset === "today") return key === todayKey;

    if (historyPreset === "yesterday") {

      const d = new Date(`${todayKey}T12:00:00`);

      d.setDate(d.getDate() - 1);

      return key === localDateKey(d);

    }

    if (historyPreset === "last7") {

      const d = new Date(`${todayKey}T12:00:00`);

      d.setDate(d.getDate() - 6);

      return key >= localDateKey(d) && key <= todayKey;

    }

    if (historyPreset === "month") return key.slice(0, 7) === todayKey.slice(0, 7);

    if (historyPreset === "custom") return (!historyStart || key >= historyStart) && (!historyEnd || key <= historyEnd);

    return true;

  }, [historyPreset, historyStart, historyEnd, todayKey]);

  const historyOrders = useMemo(() => orders.filter(o =>

    historyDateMatches(o, "created_at") &&

    (historyMethod === "all" || methodOf(o) === historyMethod) &&

    (historyStatus === "all" || o.status === historyStatus)

  ), [orders, historyDateMatches, historyMethod, historyStatus]);

  // Payment history is derived from the existing orders API, not from a payment-attempt ledger.

  const historyPayments = useMemo(() => orders.filter(o =>

    o.payment_method &&

    historyDateMatches(o, o.paid_at ? "paid_at" : "created_at") &&

    (historyMethod === "all" || methodOf(o) === historyMethod) &&

    (historyStatus === "all" || paymentOf(o) === historyStatus)

  ).sort((a, b) => new Date(b.paid_at || b.created_at) - new Date(a.paid_at || a.created_at)),

  [orders, historyDateMatches, historyMethod, historyStatus]);

  const historyPaymentTotal = historyPayments.reduce((sum, o) =>

    paymentOf(o) === "SUCCESS" ? sum + (Number(o.total) || 0) : sum, 0);

  const search = searchTerm;

  const sections = [
    ["overview", "Overview", "▦"],
    ["approval", "Pending Approval", "✓"],
    ["parcel", "New Parcel Order", "▣"],
    ["cash", "Pending Cash", "₹"],
    ["online", "Pending Online", "◷"],
    ["paid", "Successful & Bills", "▤"],
    ["failed", "Failed Online", "!"],
    ["kitchen", "Kitchen Orders", "♨"],
    ["all", "All Orders", "☷"],
    ["tables", "Table Management", "▦"],
    ["orderHistory", "Order History", "▤"],
    ["paymentHistory", "Payment History", "₹"],
  ];

  const counts = {

    approval: approvals.length, cash: visibleCash.length, paid: visibleSuccessful.length,

    failed: visibleFailed.length, online: pendingOnline.length, kitchen: kitchen.length, all: visibleOrders.length,

    tables: (tablesData.tables || []).length, orderHistory: historyOrders.length, paymentHistory: historyPayments.length,

  };

  const title = sections.find(s => s[0] === tab)?.[1] || "Overview";

  // Search across visible order information, including item names.

  // Every word in the query must match somewhere in the order.

  const matches = (o) => {

    const tokens = search.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);

    if (!tokens.length) return true;

    const items = Array.isArray(o.items) ? o.items : [];

    const searchable = [

      o.order_number, o.id, o.order_id, o.table_number, tableOf(o),

      o.order_status, o.status, methodOf(o), paymentOf(o),

      o.manager_approval_status, o.approval_status,

      o.payment?.transaction_id, o.payment?.razorpay_payment_id,

      o.customer?.name, o.customer_name, o.dining_session, o.dining_session_id, o.payment_transaction_id, o.collected_by,

      o.amount, o.total, o.order_total, o.notes,

      ...items.flatMap(item => [itemName(item), item.quantity, item.price]),

    ].filter(value => value !== null && value !== undefined)

      .map(value => typeof value === "object" ? "" : String(value))

      .join(" ").toLocaleLowerCase();

    return tokens.every(token => searchable.includes(token));

  };

  const displayOrders = (items, empty, makeAction) => {

    const filtered = items.filter(matches);

    return filtered.length ? (

      <div className="ops-order-grid">

        {filtered.map(o => {

          const config = makeAction ? makeAction(o) : {};

          return <OrderCard key={o.id || o.order_id} order={o}

            action={config.action} actionText={config.text}

            busy={busyOrderId === (o.id || o.order_id)} note={config.note} />;

        })}

      </div>

    ) : <div className="ops-empty"><div className="ops-empty-icon">⌕</div><h3>No matching orders</h3><p>{empty}</p></div>;

  };

  if (loading) return <div className="operations-page"><div className="operations-login-card">Loading Operations Dashboard...</div></div>;

  return (

    <div className="ops-dashboard ops-shell">

      {menuOpen && <button type="button" className="ops-mobile-backdrop" aria-label="Close menu" onClick={() => setMenuOpen(false)} />}

      <aside className={`ops-sidebar ${menuOpen ? "ops-sidebar-open" : ""}`}>

        <div className="ops-brand">

          <span className="ops-brand-symbol">✦</span>

          <div><strong>{staff?.restaurant?.name || "Restaurant"}</strong><small>RESTAURANT OPERATIONS</small></div>

          <button type="button" className="ops-menu-close" onClick={() => setMenuOpen(false)} aria-label="Close navigation">×</button>

        </div>

        <div className="ops-nav-label">WORKSPACE</div>

        <nav className="ops-nav" aria-label="Dashboard navigation">

          {sections.map(([key, name, symbol]) => (

            <button key={key} type="button" className={`ops-nav-item ${tab === key ? "ops-nav-active" : ""}`}

              onClick={() => { setTab(key); setMenuOpen(false); setCollecting(null); setSearchTerm(""); }}>

              <span className="ops-nav-symbol" aria-hidden="true">{symbol}</span>

              <span>{name}</span>

              {counts[key] != null && <span className="ops-nav-count">{counts[key]}</span>}

            </button>

          ))}

        </nav>

        <div className="ops-sidebar-bottom">

          <span className="ops-live-dot" /> Live updates every 5 seconds

          <div className="ops-sidebar-user"><span className="ops-avatar">{(staff?.user?.username || "S").charAt(0).toUpperCase()}</span>

            <div><strong>{staff?.user?.username || "Staff"}</strong><small>{staff?.role || "Operations"}</small></div>

          </div>

        </div>

      </aside>

      <div className="ops-main">

        <header className="ops-topbar">

          <div className="ops-topbar-left">

            <button type="button" className="ops-mobile-menu" aria-label="Open navigation" onClick={() => setMenuOpen(true)}>☰</button>

            <div className="ops-breadcrumb">Restaurant <span>/</span> <strong>{title}</strong></div>

          </div>

          <div className="ops-topbar-right">

            <span className="ops-online-label"><span className="ops-live-dot" /> System Live</span>

            <button type="button" className="ops-topbar-refresh ops-topbar-sound"
            onClick={() => soundEnabled ? disableSound() : enableSound().catch(err => setError(err.message))}>
            {soundEnabled ? "🔊 Sound On" : "🔇 Enable Sound"}
          </button>
          <button className="ops-topbar-refresh" type="button" onClick={refresh} disabled={refreshing}>

              ↻ <span>{refreshing ? "Refreshing..." : "Refresh"}</span>

            </button>

            <button className="ops-topbar-logout" type="button" onClick={logout} disabled={loggingOut}>

              {loggingOut ? "Logging out..." : "Logout"}

            </button>

          </div>

        </header>

        <main className="ops-content">

          <div className="ops-page-intro">

            <div><span className="ops-eyebrow">RESTAURANT MANAGEMENT</span><h1>{title}</h1>

              <p>Manage approvals, payments, kitchen orders and receipts in one place.</p></div>

            <span className="ops-date">{new Date(`${todayKey}T12:00:00`).toLocaleDateString(undefined, { weekday:"short", month:"short", day:"numeric", year:"numeric" })}</span>

          </div>

          {error && <div className="operations-error" role="alert">{error}</div>}

          {success && <div className="ops-approved-message" role="status">{success}</div>}

          {tab === "parcel" && <ParcelOrders restaurantSlug={restaurantId} onCreated={() => loadAll(true)} />}

          {tab === "tables" && (

            <section className="ops-tables-section">

              <div className="ops-tables-header">

                <div><h2>Restaurant Tables</h2><p>Permanent QR identifiers. Availability follows active dining sessions.</p></div>

                <div className="ops-table-actions">

                  <button type="button" onClick={() => loadTables()} disabled={tableBusy}>↻ Refresh</button>

                  {["OWNER", "MANAGER", "CASHIER"].includes(staff?.role) &&

                    <button type="button" className="ops-primary-btn" onClick={() => setTableForm({table_number:"", capacity:4})}>+ Add Table</button>}

                </div>

              </div>

              <div className="ops-table-summary">

                <div><strong>{tablesData.count || 0}</strong><span>Total</span></div>

                <div><strong>{tablesData.available || 0}</strong><span>Available</span></div>

                <div><strong>{tablesData.occupied || 0}</strong><span>Occupied</span></div>

                <div><strong>{tablesData.inactive || 0}</strong><span>Inactive</span></div>

              </div>

              <div className="ops-table-grid">

                {(tablesData.tables || []).map(t => (

                  <article key={t.id} className="ops-table-card">

                    <div className="ops-table-card-head"><h3>Table {t.table_number}</h3>

                      <span className={`ops-table-pill ${t.availability.toLowerCase()}`}>{t.availability}</span></div>

                    <p>Seats: {t.capacity}</p>

                    <p>Session: {t.active_session ? `#${t.active_session.id}` : "None"}</p>

                    <div className="ops-table-card-actions">

                      <button type="button" onClick={() => viewTable(t.id)}>Details</button>

                      {["OWNER", "MANAGER", "CASHIER"].includes(staff?.role) && <>

                        <button type="button" onClick={() => setTableForm({id:t.id,table_number:t.table_number,capacity:t.capacity})}>Edit</button>

                        {t.availability === "OCCUPIED" ?

                          <button type="button" disabled={tableBusy} onClick={() => tableAction(() => closeOperationsTableSession(restaurantId,t.id), `Close session for Table ${t.table_number}? All orders must be settled and served.`)}>Close Session</button> :

                          t.availability === "AVAILABLE" ?

                            <button type="button" disabled={tableBusy} onClick={() => tableAction(() => openOperationsTableSession(restaurantId,t.id), `Open a dining session for Table ${t.table_number}?`)}>Open Session</button> : null}

                        {t.availability !== "OCCUPIED" &&

                          <button type="button" disabled={tableBusy} onClick={() => tableAction(() => updateOperationsTable(restaurantId,t.id,{is_active:!t.is_active}), `${t.is_active ? "Deactivate" : "Activate"} Table ${t.table_number}?`)}>{t.is_active ? "Deactivate" : "Activate"}</button>}

                      </>}

                    </div>

                  </article>

                ))}

              </div>

              {!(tablesData.tables || []).length && <div className="ops-empty">No tables found. Add your first table.</div>}

              <p className="ops-history-note">QR identifiers are permanent. Closing a dining session never deletes orders, bills, or payment history.</p>

            </section>

          )}

          {(tab === "orderHistory" || tab === "paymentHistory") && (

            <section className="ops-panel ops-history-panel">

              <div className="ops-panel-heading">

                <div><h2>{tab === "orderHistory" ? "Order History" : "Payment History"}</h2>

                  <p>{tab === "orderHistory" ? "Find past orders without affecting today's dashboard." : "Recorded payment states; date uses payment date when available."}</p></div>

                <span className="ops-result-count">{tab === "orderHistory" ? historyOrders.length : historyPayments.length} records</span>

              </div>

              <div className="ops-history-filters">

                <label>Period<select value={historyPreset} onChange={e => setHistoryPreset(e.target.value)}>

                  <option value="today">Today</option><option value="yesterday">Yesterday</option>

                  <option value="last7">Last 7 Days</option><option value="month">This Month</option>

                  <option value="custom">Custom Range</option><option value="all">All History</option>

                </select></label>

                {historyPreset === "custom" && <><label>From<input type="date" value={historyStart} max={historyEnd || undefined} onChange={e => setHistoryStart(e.target.value)} /></label>

                  <label>To<input type="date" value={historyEnd} min={historyStart || undefined} onChange={e => setHistoryEnd(e.target.value)} /></label></>}

                <label>Method<select value={historyMethod} onChange={e => setHistoryMethod(e.target.value)}>

                  <option value="all">All Methods</option><option value="CASH">Cash</option><option value="ONLINE">Online</option>

                  <option value="CARD">Card</option><option value="UPI">UPI</option>

                </select></label>

                <label>Status<select value={historyStatus} onChange={e => setHistoryStatus(e.target.value)}>

                  <option value="all">All Statuses</option>

                  {(tab === "orderHistory" ? ["PENDING", "CONFIRMED", "PREPARING", "READY", "SERVED", "COMPLETED", "CANCELLED"] : ["PENDING", "SUCCESS", "FAILED", "REFUNDED"]).map(value =>

                    <option value={value} key={value}>{value}</option>)}

                </select></label>

                <label className="ops-history-search">Search<input type="search" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} placeholder="Order, table, transaction..." /></label>

              </div>

              {tab === "paymentHistory" && <div className="ops-history-total">Successful payments in selected records: <strong>{currency(historyPaymentTotal)}</strong></div>}

              <div className="ops-history-table-wrap"><table className="ops-history-table">

                <thead><tr>{(tab === "orderHistory" ? ["Order Date", "Order", "Table", "Kitchen", "Payment", "Amount", "Action"] :

                  ["Payment Date", "Order", "Table", "Method", "Status", "Amount", "Cashier / Reference", "Receipt"]).map(h => <th key={h}>{h}</th>)}</tr></thead>

                <tbody>

                  {(tab === "orderHistory" ? historyOrders : historyPayments).filter(matches).map(o => (

                    <tr key={o.id}>

                      <td>{formatHistoryDate(tab === "paymentHistory" ? (o.paid_at || o.created_at) : o.created_at)}</td>

                      <td><strong>#{o.order_number || o.id}</strong></td><td>{tableOf(o)}</td>

                      {tab === "orderHistory" ? <><td>{o.status}</td><td>{methodOf(o)} · {paymentOf(o)}</td>

                        <td>{currency(o.total)}</td><td>{o.payment_status === "PAID" && paymentOf(o) === "SUCCESS" && o.manager_approval_status === "APPROVED" ?

                          <button type="button" onClick={() => setPrintOrder(o)}>Print Receipt</button> : "—"}</td></> :

                        <><td>{methodOf(o)}</td><td>{paymentOf(o)}</td><td>{currency(o.total)}</td>

                          <td>{o.collected_by || o.payment_transaction_id || "—"}</td>

                          <td>{paymentOf(o) === "SUCCESS" && o.manager_approval_status === "APPROVED" ?

                            <button type="button" onClick={() => setPrintOrder(o)}>Print Receipt</button> : "—"}</td></>}

                    </tr>

                  ))}

                </tbody>

              </table></div>

              {!(tab === "orderHistory" ? historyOrders : historyPayments).filter(matches).length && <p className="ops-empty">No history matches these filters.</p>}

              <p className="ops-history-note">Historical orders are never deleted by date filtering. Payment history shows the latest payment record per order, not every retry attempt.</p>

            </section>

          )}

          {tab !== "tables" && tab !== "tables" && tab !== "orderHistory" && tab !== "paymentHistory" && (

            <div className="ops-daily-filters">

              <label>Dashboard Date

                <select value={datePreset} onChange={e => setDatePreset(e.target.value)}>

                  <option value="today">Today</option><option value="yesterday">Yesterday</option>

                  <option value="last7">Last 7 Days</option><option value="custom">Custom Range</option>

                  <option value="all">All History</option>

                </select>

              </label>

              {datePreset === "custom" && <>

                <label>From<input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} /></label>

                <label>To<input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} /></label>

              </>}

              <span>Daily view resets automatically at midnight. Older records remain in History.</span>

            </div>

          )}

          {tab === "overview" && (

            <label className="ops-search ops-global-search"><span>⌕</span>

              <input value={search} onChange={e => setSearchTerm(e.target.value)}

                placeholder="Search all orders by number, table, item or payment..."

                aria-label="Search all restaurant orders" />

            </label>

          )}

          <div className="ops-stats">

            {[

              ["Total Orders", visibleOrders.length, "▤", "blue", "all"],

              ["Awaiting Approval", approvals.length, "◷", "amber", "approval"],

              ["Pending Cash", visibleCash.length, "₹", "violet", "cash"],

              ["Successful Orders", visibleSuccessful.length, "✓", "green", "paid"],

              ["Failed Online", visibleFailed.length, "!", "rose", "failed"],

              ["In Kitchen", kitchen.length, "♨", "cyan", "kitchen"],

            ].map(([label, value, symbol, tone, target]) => (

              <button key={label} type="button" className="ops-stat-card" onClick={() => { setTab(target); setSearchTerm(""); }}>

                <span className={`ops-stat-icon ops-tone-${tone}`}>{symbol}</span>

                <span className="ops-stat-label">{label}</span><strong>{value}</strong>

                <span className="ops-stat-link">View orders →</span>

              </button>

            ))}

          </div>

{(tab === "tables" || tab === "orderHistory" || tab === "paymentHistory") ? null : tab === "overview" && search.trim() ? (

  <section className="ops-panel ops-orders-panel">

    <div className="ops-panel-heading">

      <div>

        <h2>Search Results</h2>

        <p>Search across all restaurant orders</p>

      </div>

    </div>

    {displayOrders(

      orders,

      "No orders match your search.",

      (o) => ({

        action: canApprove(o)

          ? () => approve(o.id)

          : undefined,

        text: "Approve & Send to Kitchen",

      })

    )}

  </section>

) : tab === "overview" ? (

            <div className="ops-overview-grid">

              <section className="ops-panel">

                <div className="ops-panel-heading"><div><h2>Needs Your Attention</h2><p>Orders requiring a manager or cashier action</p></div></div>

                <div className="ops-quick-actions">

                  <button type="button" onClick={() => setTab("approval")}><span>◷</span><strong>Pending Approvals</strong><b>{approvals.length}</b></button>

                  <button type="button" onClick={() => setTab("cash")}><span>₹</span><strong>Cash to Collect</strong><b>{visibleCash.length}</b></button>

                  <button type="button" onClick={() => setTab("failed")}><span>!</span><strong>Failed Online</strong><b>{visibleFailed.length}</b></button>

                </div>

              </section>

              <section className="ops-panel">

                <div className="ops-panel-heading"><div><h2>Recent Orders</h2><p>Latest restaurant activity</p></div>

                  <button type="button" className="ops-text-link" onClick={() => setTab("all")}>View all →</button></div>

                <div className="ops-recent-list">

                  {visibleOrders.slice(0, 6).map(o => (

                    <div className="ops-recent-row" key={o.id}>

                      <div><strong>#{o.order_number || o.id}</strong><small>Table {tableOf(o)} · {methodOf(o)}</small></div>

                      <div className="ops-recent-right"><strong>{currency(amountOf(o))}</strong><small>{o.status} · {paymentOf(o)}</small></div>

                    </div>

                  ))}

                  {!visibleOrders.length && <p>No orders yet.</p>}

                </div>

              </section>

            </div>

          ) : (

            <section className="ops-panel ops-orders-panel">

              <div className="ops-panel-heading">

                <div><h2>{title}</h2><p>{tab === "cash" ? "Only approved, unpaid cash orders. Collect before or after serving." :

                  tab === "paid" ? "Approved and fully paid orders. Print individual receipts." :

                  tab === "failed" ? "Current failed online payment states, kept out of cash collection." :

                  tab === "approval" ? "Approve eligible orders to send them to the kitchen." :

                  tab === "online" ? "Online payments awaiting successful verification." :

                  tab === "kitchen" ? "Approved orders currently in kitchen workflow." : "All orders for this restaurant."}</p></div>

                <span className="ops-result-count">{counts[tab] || 0} orders</span>

              </div>

              <div className="ops-toolbar">

                <label className="ops-search"><span>⌕</span>

                  <input value={search} onChange={e => setSearchTerm(e.target.value)}

                    placeholder="Search order, table, payment..." aria-label="Search orders" /></label>

                <button type="button" onClick={refresh} disabled={refreshing}>↻ Refresh</button>

              </div>

              {tab === "approval" && displayOrders(approvals, "No orders ready for approval.", o => ({

                action: () => approve(o.id), text: "Approve & Send to Kitchen",

                note: methodOf(o) === "CASH" ? "Cash collection is separate from approval." : "Online payment verified.",

              }))}

              {tab === "cash" && (

                <>

                  {visibleCash.filter(matches).length ? <div className="ops-order-grid">

                    {visibleCash.filter(matches).map(p => (

                      <article className="ops-order-card" key={p.payment_id || p.order_id}>

                        <div className="ops-order-header"><div><h3>Order #{p.order_number || p.order_id}</h3>

                          <p>Table {p.table_number ?? "—"} · Order ID {p.order_id}</p></div>

                          <span className="ops-status pending">UNPAID</span></div>

                        <div className="ops-order-details"><p><strong>Kitchen:</strong> {p.order_status}</p>

                          <p><strong>Approval:</strong> {p.approval_status}</p>

                          <p><strong>Payment:</strong> CASH · PENDING</p></div>

                        <div className="ops-order-footer"><strong>{currency(p.amount)}</strong>

                          <button type="button" className="ops-approve-btn" disabled={busyOrderId !== null}

                            onClick={() => setCollecting(p)}>Collect Cash</button></div>

                      </article>

                    ))}

                  </div> : <div className="ops-empty"><div className="ops-empty-icon">✓</div><h3>No cash to collect</h3><p>No matching approved cash orders awaiting payment.</p></div>}

                  {collecting && <div className="ops-dialog-backdrop" role="presentation" onClick={() => { if (busyOrderId === null) setCollecting(null); }}>

                    <div className="ops-dialog" role="dialog" aria-modal="true" aria-label="Confirm cash collection" onClick={e => e.stopPropagation()}>

                      <div className="ops-dialog-symbol">₹</div><h2>Confirm Cash Collection</h2>

                      <p>Order #{collecting.order_number || collecting.order_id} · Table {collecting.table_number ?? "—"}</p>

                      <div className="ops-dialog-amount"><span>Amount received</span><strong>{currency(collecting.amount)}</strong></div>

                      <p>Confirm only after physically receiving the full amount. This action records the payment as successful.</p>

                      <div className="ops-dialog-actions"><button type="button" className="ops-secondary-btn" disabled={busyOrderId !== null}

                        onClick={() => setCollecting(null)}>Cancel</button>

                        <button type="button" className="ops-primary-btn" disabled={busyOrderId !== null} onClick={collect}>

                          {busyOrderId !== null ? "Recording..." : "Confirm Cash Received"}</button></div>

                    </div>

                  </div>}

                </>

              )}

              {tab === "paid" && displayOrders(visibleSuccessful, "No successful paid orders found.", o => ({

                action: () => setPrintOrder(o), text: "Print Bill / Receipt", note: "Verified successful payment",

              }))}

              {tab === "failed" && displayOrders(visibleFailed, "No failed online orders found.", () => ({

                note: "Online payment failed. This order must not be sent to the kitchen.",

              }))}

              {tab === "online" && displayOrders(pendingOnline, "No pending online payments.", () => ({

                note: "Waiting for verified online payment.",

              }))}

              {tab === "kitchen" && displayOrders(kitchen, "No active kitchen orders.", () => ({

                note: "Kitchen status is independent of payment collection.",

              }))}

              {tab === "all" && displayOrders(visibleOrders, "No orders found.", o => ({

                action: canApprove(o) ? () => approve(o.id) : undefined,

                text: "Approve & Send to Kitchen",

              }))}

            </section>

          )}

          <div className="ops-footnote">Restaurant #{restaurantId} · Orders are refreshed automatically every 5 seconds.</div>

        </main>

      </div>

      {tableForm && <div className="ops-dialog-backdrop" role="dialog" aria-modal="true" aria-label="Table editor">

        <form className="ops-dialog ops-table-form" onSubmit={saveTable}>

          <h2>{tableForm.id ? "Edit Table" : "Add Table"}</h2>

          <label>Table number<input required maxLength={30} value={tableForm.table_number} onChange={e => setTableForm({...tableForm,table_number:e.target.value})}/></label>

          <label>Seating capacity<input required type="number" min="1" max="1000" value={tableForm.capacity} onChange={e => setTableForm({...tableForm,capacity:e.target.value})}/></label>

          <p>Permanent QR identifier is assigned by the backend and is not changed by editing.</p>

          <div className="ops-dialog-actions"><button type="button" className="ops-secondary-btn" onClick={() => setTableForm(null)}>Cancel</button>

            <button type="submit" className="ops-primary-btn" disabled={tableBusy}>{tableBusy ? "Saving..." : "Save Table"}</button></div>

        </form>

      </div>}

      {tableDetail && <div className="ops-dialog-backdrop" role="dialog" aria-modal="true" aria-label="Table details">

        <div className="ops-dialog ops-table-detail">

          <div className="ops-tables-header"><h2>Table {tableDetail.table.table_number}</h2><button type="button" className="ops-secondary-btn" onClick={() => setTableDetail(null)}>Close</button></div>

          <p>Status: <strong>{tableDetail.table.availability}</strong> · Seats: {tableDetail.table.capacity}</p>

          <p>Permanent QR identifier: <code>{tableDetail.table.qr_code}</code></p>

          <p className="ops-history-note">The QR identifier is not a customer URL. Use your existing restaurant QR routing to generate the printable link.</p>

          <h3>Recent orders (individual bills)</h3>

          <div className="ops-table-detail-list">{(tableDetail.orders || []).map(o => <div key={o.id}>

            <strong>#{o.order_number}</strong> · {o.status} · {o.payment_status} · {currency(o.total)}

            <small>Session #{o.dining_session_id || "—"} · {formatHistoryDate(o.created_at)}</small>

          </div>)}{!(tableDetail.orders || []).length && <p>No orders.</p>}</div>

          <h3>Dining sessions</h3>

          <div className="ops-table-detail-list">{(tableDetail.sessions || []).map(s => <div key={s.id}>

            Session #{s.id} · {s.is_active ? "Active" : "Closed"}<small>{formatHistoryDate(s.created_at)} — {s.closed_at ? formatHistoryDate(s.closed_at) : "Ongoing"}</small>

          </div>)}</div>

        </div>

      </div>}

      {printOrder && <PrintBill order={printOrder} restaurant={staff?.restaurant?.name}

        onClose={() => setPrintOrder(null)} />}

    </div>

  );

}